module.exports = __webpack_public_path__ + "img/Monte_Kope_103.c5dbca4e.jpg";